import { Component, OnInit } from '@angular/core';
import {RealmService} from '../Services/Realm/realm.service';
import {Router} from '@angular/router';
import {MenuItem} from 'primeng/api';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-provider-detail',
  templateUrl: './provider-detail.component.html',
  styleUrls: ['./provider-detail.component.css', '../../assets/layout/style/layout.css']
})
export class ProviderDetailComponent implements OnInit {
  specialties = [];
  providers: any[] = [];
  sortField: string;
  sortOrder: number;
  selectedProvider: any = null;
  displayDialog: boolean;
  displayDialogUbication: boolean;
  infoProviders = [];
  cant = 1;
  showProviders = false;
  showSpecialty = false;
  quequeVariable: string;
  displayWaitDialog: boolean;
  env = environment;
  private items: MenuItem[];
  constructor(private realm: RealmService, private router: Router) { }

  ngOnInit(): void {
    this.env.showSteps = false;
    this.env.isContentLoading = true;
    this.sortOrder = 1;
    this.sortField = 'strDescription';
    this.getSpecialty();
  }
  getSpecialty() {
    this.providers = [];
    this.specialties = [];
    this.realm.getSpecialtyList().then((data: any) => {
      this.specialties = data;
      this.showSpecialty = true;
      this.env.isContentLoading = false;
    });
    this.items = [
      {label: 'Categories', url: 'specialty'},
    ];
  }
  getProvider(obj) {
    this.env.isContentLoading = true;
    this.router.navigate(['home/providersearch', 'resultados', 'provider-detail', '502', '1', '', '', obj, '', '']);
  }
  selectProvider(event: Event, provider: any) {
    console.log('selected provider', provider);
    provider.data.forEach(val => {
      this.infoProviders.push(val);
    });
    this.displayDialogUbication = true;
    if (provider.queque > 0) {
      this.quequeVariable = 'Esperar en cola';
    } else {
      this.quequeVariable = 'Entrar a consulta en linea.';
    }
    this.showProviders = false;
  }
  selectedLocation(event: Event, info: any) {
    this.selectedProvider = info;
    this.cant = 1;
    this.displayDialog = true;
    event.preventDefault();
  }
  minus() {
    if (this.cant > 1) {
      this.cant = this.cant - 1;
    }
  }
  telemedicine() {
    this.displayWaitDialog = true;
    this.displayDialogUbication = false;
   // this.router.navigate(['/telemedicine']);
  }
  back() {
    this.router.navigate(['home/providers']);
  }

}
